import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import HomepageSliderBody from './Body';
import { HomepageSliderSchema } from './schema';
import {
  listItemsNeedNormalization,
  normalizeObjectList,
} from '../../../helpers/homepageUtils';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = HomepageSliderSchema({ intl });

  useEffect(() => {
    const slides = data.slides || [];
    if (listItemsNeedNormalization(slides)) {
      onChangeBlock(block, { ...data, slides: normalizeObjectList(slides) });
    }
  }, [block, data, onChangeBlock]);

  return (
    <>
      <div className="homepage-slider-preview">
        <HomepageSliderBody slides={data.slides} editPreview />
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withBlockExtensions(Edit);
